import React, { useEffect, useState, useCallback } from 'react';

let logoutTimer;

const AuthContext = React.createContext({
  session: null,
  isLoggedIn: false,
  login: (session) => {},
  logout: () => {}
});

const calculateRemainingTime = (expirationTime) => {
  const currentTime = new Date().getTime();
  const adjExpiresTime = new Date(expirationTime).getTime();
  const remainingDuration = adjExpiresTime - currentTime;

  return remainingDuration;
};

const retrieveStoredSession = () => {
  const storedSession = JSON.parse(localStorage.getItem('session'));
  const storedExpirationDate = localStorage.getItem('expirationTime');

  const remainingTime = calculateRemainingTime(storedExpirationDate);

  if (remainingTime <= 3600) {
    localStorage.removeItem('session');
    localStorage.removeItem('expirationTime');
    return null;
  }

  return { session: storedSession, duration: remainingTime };
};

export const AuthContextProvider = (props) => {
  const sessionData = retrieveStoredSession();
  let initialSession;
  if (sessionData) {
    initialSession = sessionData.session;
  }

  const [session, setSession] = useState(initialSession);

  const userIsLoggedIn = !!session;
  const loginHandler = (session, expirationTime) => {
    setSession(session);
    localStorage.setItem('session', JSON.stringify(session));
    localStorage.setItem('expirationTime', expirationTime);

    const remainingDuration = calculateRemainingTime(expirationTime);
    logoutTimer = setTimeout(logoutHandler, remainingDuration);
  };

  const logoutHandler = useCallback(() => {
    setSession(null);
    localStorage.removeItem('session');
    localStorage.removeItem('expirationTime');
    if (logoutTimer) {
      clearTimeout(logoutTimer);
    }
  }, []);

  useEffect(() => {
    if (sessionData) {
      logoutTimer = setTimeout(logoutHandler, sessionData.duration);
    }
  }, [sessionData, logoutHandler]);

  const contextValue = {
    session: session,
    isLoggedIn: userIsLoggedIn,
    login: loginHandler,
    logout: logoutHandler
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
